/** @format */
import {
    Image,
    RichText,
    UrlSlugParamsType,
} from '@toucan/client/core/contentful';

export enum EntryType {
    INLINE = 'inline',
    BLOCK = 'block',
    HYPERLINK = 'hyperlink',
}

export enum LandingPageHeroRenderType {
    CURVE = 'CURVE',
    MAIN_MIDNIGHT = 'MAIN_MIDNIGHT',
    MAIN_MIDNIGHT_GRADIENT = 'MAIN_MIDNIGHT_GRADIENT',
    MAIN_SUSTAINABILITY_GRADIENT = 'MAIN_SUSTAINABILITY_GRADIENT',
}

export type LandingPageContent = {
    content: RichText | null;
};

export type LandingPageData = UrlSlugParamsType & {
    __typename: string;
    sys: {
        id: string;
    };
    title: string;
    description: string;
    heroImage: Image | null;
    heroButtonText: string | null;
    heroButtonLink: string | null;
    heroRenderType: LandingPageHeroRenderType;
    seoTitle: string | null;
    seoDescription: string | null;
    disableSearchEngineIndexing: boolean | null;
    enableTrustPilotWidgetInHero: boolean | null;
};

export type LandingPageDataResponse = {
    landingPageCollection?: {
        items?: LandingPageData[];
    };
};

export type LandingPageContentResponse = {
    landingPageCollection?: {
        items?: LandingPageContent[];
    };
};
